import { render, staticRenderFns } from "./EditSubject.vue?vue&type=template&id=1259e85b&scoped=true&"
import script from "./EditSubject.vue?vue&type=script&lang=js&"
export * from "./EditSubject.vue?vue&type=script&lang=js&"
import style0 from "./EditSubject.vue?vue&type=style&index=0&id=1259e85b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1259e85b",
  null
  
)

export default component.exports